import React, { useEffect, useState } from "react";
import styles from "./Awards.module.css";
import axios from "axios";
import { Spinner } from "react-bootstrap";
// import example from "../../../assets/img/example/example_aw.png"
// import exampleTwo from "../../../assets/img/example/example.png"

export const Awards = ({
  token,
  user,
  setAwardSaved,
  awardSaved,
  dataUser,
  setShowPopupPay,
  setShowPopupAwards,
  loadingGetData,
  handleContinue,
}) => {
  const [awards, setAwards] = useState([]);
  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [productId, setProductId] = useState([]);

  const handleGetAwards = async () => {
    setLoader(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/incentivos?id=${user.cliente_id}`,
        {
          headers: {
            Authorization: `Bearer ${token ?? ""}`,
          },
        }
      );
      if (res?.data?.detalle.detalle_premios.length > 0) {
        setAwards([
          ...res?.data?.detalle.detalle_premios,
          {
            tipo_incentivo_id: "No deseo agregar premio",
            producto_id: "0",
            campania_id: "0",
            descripcion: "NO DESEO PREMIO",
          },
        ]);
      } else {
        setAwards([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const handleSubmit = async () => {
    setButtonLoader(true);
    try {
      await handleContinue(awardSaved);
    } catch (error) {
      console.error(error);
    } finally {
      setButtonLoader(false);
      setShowPopupPay(true);
      setShowPopupAwards(false);
    }
  };

  useEffect(() => {
    handleGetAwards();
  }, []);

  return (
    <div className={styles.backgroundAwards}>
      <div className={styles.contenedorAwards}>
        {loader ? (
          <div className={styles.cargandoContainer}>
            <div className={styles.spinner}></div>
            <div className={styles.contenedorTexto}>
              <h2>Cargando...</h2>
              <p className={styles.parrafo}>
                Por favor, espere mientras se carga.
              </p>
            </div>
          </div>
        ) : (
          <>
            {awards.length > 1 ? (
              <>
                <div className={styles.entregaContenedor}>
                  <h3 className={styles.TituloEntrega}>Premio(s) de campaña</h3>
                </div>
                <div className={styles.inputSelectFormAwards}>
                  {awards?.map(
                    ({
                      tipo_incentivo_id,
                      producto_id,
                      campania_id,
                      descripcion,
                      imagen,
                    }) => (
                      <div key={campania_id} className={styles.containerCheck}>
                        <input
                          className={styles.chetRecoger}
                          type="checkbox"
                          onChange={(e) => {
                            const existProductId = productId.some(
                              (p) => p === producto_id
                            );

                            if (
                              tipo_incentivo_id === "No deseo agregar premio"
                            ) {
                              setAwardSaved([
                                {
                                  tipo_incentivo_id: "No deseo agregar premio",
                                  producto_id: "0",
                                  campania_id: "0",
                                  descripcion: "NO DESEO PREMIO",
                                },
                              ]);

                              setProductId([]);
                              return;
                            }
                            if (
                              awardSaved.some(
                                (a) => a.producto_id === producto_id
                              )
                            ) {
                              const newAward = awardSaved.filter(
                                (a) => a.producto_id !== producto_id
                              );
                              const newProductId = productId.filter(
                                (p) => p !== producto_id
                              );
                              setProductId(newProductId);

                              if (newAward.length === 0) {
                                setAwardSaved([
                                  {
                                    tipo_incentivo_id:
                                      "No deseo agregar premio",
                                    producto_id: "0",
                                    campania_id: "0",
                                    descripcion: "NO DESEO PREMIO",
                                  },
                                ]);
                              } else {
                                setAwardSaved(newAward);
                              }
                            } else {
                              const newAward = awardSaved.filter(
                                (a) =>
                                  a.tipo_incentivo_id !==
                                  "No deseo agregar premio"
                              );

                              setAwardSaved([
                                ...newAward,
                                {
                                  tipo_incentivo_id,
                                  quantity: 1,
                                  idPedido: dataUser?.carrito?.[0].idPedido,
                                  imagen,
                                  producto_id,
                                  campania_id,
                                  descripcion,
                                },
                              ]);

                              !existProductId &&
                                setProductId([...productId, producto_id]);
                            }
                          }}
                          checked={awardSaved.some(
                            (a) => a.producto_id === producto_id
                          )}
                        />
                        {producto_id !== "0" && (
                          <img
                            className={styles.imageAward}
                            src={`${process.env.REACT_APP_API_URL}/img/${imagen[0]}`}
                            // src={imagen}
                            alt="imagen de ejemplo"
                          />
                        )}
                        <label htmlFor="" className={styles.parrafoRecoger}>
                          {tipo_incentivo_id}
                        </label>
                      </div>
                    )
                  )}
                </div>
              </>
            ) : (
              <p className={styles.noAwardsMessage}>
                No tienes premios por reclamar
              </p>
            )}
            <button
              className={styles.BtnFinalizar}
              id="btPagar"
              disabled={loadingGetData}
              onClick={() => {
                handleSubmit();
              }}
            >
              {buttonLoader || loadingGetData ? (
                <Spinner animation="border" role="status" size="sm">
                  <span className="visually-hidden">Cargando...</span>
                </Spinner>
              ) : (
                "Continuar"
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
